import { delay, put, takeLatest, call } from "redux-saga/effects";
import { logout, updateAuth } from "../Reducers/authReducer";
import {
  CancelSubscription,
  ChangePasswordAction,
  EditBasicInfoAction,
  GetAllPaymentMethods,
  GetUserDetail,
  GetWishlistItemsAction,
  LoginAction,
  LogoutAction,
  RegisterAction,
  ToggleWishlistItemAction,
  resetPasswordAction,
  resetPasswordRequestAction,
  GetMySubscription,
  VerifyOtpAction,
  SendOtpAction,
  RenewSubscription
  
} from "../Actions/action";
import * as authServie from "../../services/authService";
import * as paymentServie from "../../services/paymentService";
import { toast } from "react-toastify";
import { apiResponse, onError } from "../../helper/helper";
import { updateItem } from "../Reducers/itemReducer";
import { toastConfiguration } from "../../Constant/Data";
import { adminLogout } from "../Reducers/Admin/adminAuthReducer";
function* editBasicInfoSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.editBasicInfo,
      payload
    );
    if (ok) {
      let { data: userData } = data || {};
      toast.success("Edit Successfully", toastConfiguration);
      yield put(updateAuth({ userData }));
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong");
    // console.log("error-----------", error);
  }
}
function* changePasswordSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.changePassword,
      payload
    );
    if (ok) {
      toast.success(
        "Your password has been changed successfully",
        toastConfiguration
      );
      yield delay(200);
      yield put(updateAuth({ changeSuccess: true }));
      yield delay(500);
      yield put(updateAuth({ changeSuccess: false }));
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message, toastConfiguration));
    }
  } catch (error) {
    toast.error("Something Went Wrong", toastConfiguration);
    // console.log("error-----------", error);
  }
}
function* registerSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.register,
      payload
    );
    if (ok) {
      toast.success(
        "Your Account Has Been Registered Successfully",
        toastConfiguration
      );
      yield put(updateAuth({ registerSuccess: true }));
      yield delay(500);
      yield put(updateAuth({ registerSuccess: false }));
    } else {
      if (data?.email) {
        toast.error(apiResponse(data.email), toastConfiguration);
        return;
      }
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* sendOtpSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.ReSendOTP,
      payload
    );
    if (ok) {
      toast.success(
     "OTP has been sent to your email address successfully",
        toastConfiguration
      );
      // yield put(updateAuth({ OTPSuccess: true }));
      // yield delay(500);
      // yield put(updateAuth({ OTPSuccess: false }));
    } else {
      if (data?.message) {
        toast.error(apiResponse(data.message), toastConfiguration);
        return;
      }
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* verifyUserSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.VerifyUser,
      payload
    );
    if (ok) {
      toast.success(
        "Your Email address has been verified.",
        toastConfiguration
      );
      yield put(updateAuth({ OTPSuccess: true }));
      yield delay(500);
      yield put(updateAuth({ OTPSuccess: false }));
    } else {
      if (data?.email) {
        toast.error(apiResponse(data.message), toastConfiguration);
        return;
      }
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}

function* resetPasswordRequestSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.resetPasswordRequest,
      payload
    );
    if (ok) {
      toast.success(
        "Password reset link sent successfully",
        toastConfiguration
      );
      yield put(
        updateItem({
          emailSent: true,
        })
      );
    } else {
      if (data?.error) {
        toast.error(apiResponse(data?.error), toastConfiguration);
        return;
      }
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  }
}
function* resetPasswordSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(
      authServie.resetPassword,
      payload
    );

    if (ok) {
      toast.success(
        "Your password has been reset successfully",
        toastConfiguration
      );
      yield put(
        updateAuth({
          resetSuccess: true,
        })
      );
      yield delay(500);
      yield put(updateAuth({ resetSuccess: false }));
    } else {
      if (data?.error) {
        toast.error(apiResponse(data?.error), toastConfiguration);
        return;
      }
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  }
}
function* loginSaga({ payload }) {
  try {
    const { ok, data, originalError } = yield call(authServie.login, payload);
    // console.log("login data-----------", data);
    if (ok) {
      if(data?.user?.role==="admin"){
   toast.error("Invalid Credentials")
      }
      else{
        toast.success("Login Successfully", toastConfiguration);
        let { user: userData,token,subscription } = data || {};
        yield put(
          updateAuth({
            userData,
            token,
            subscription,
            loginSuccess: true,
          })
        );
        yield put(adminLogout())
        yield delay(500);
        yield put(updateAuth({ loginSuccess: false }));
      }
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* logoutSaga() {
        toast.success("Logout Successfully", toastConfiguration);
        // yield put()
      yield put(logout());
      yield put(adminLogout())
  // try {
  //   const { ok, data, originalError } = yield call(authServie.logout);
  //   if (ok) {
  //     toast.success("Logout Successfully", toastConfiguration);
  //     yield put(logout());
  //   } else {
  //     onError(data, originalError);
  //     yield put(logout());
  //   }
  // } catch (error) {
  //   toast.error("Something Went Wrong ", toastConfiguration);
  // }
}
function* getUserDetailSaga(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      authServie.getUserDetail,
   action?.payload
    );
    if (ok) {
      const { user:userData,subscription} = data || {};
      yield put(
        updateAuth({
          userData,
          subscription
        })
      );
    } else {
      // if (status === 404) {
      //   yield put(
      //     updateAuth({
      //       wishlistItems: [],
      //     })
      //   );
      //   return;
      // }
      // onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* getWishlistItemsSaga(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      authServie.getWishListItem,
      {}
    );
    if (ok) {
      const { data: wishlistItems } = data || {};
      yield put(
        updateAuth({
          wishlistItems,
        })
      );
    } else {
      if (status === 404) {
        yield put(
          updateAuth({
            wishlistItems: [],
          })
        );
        return;
      }
      onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* getAllPaymentMethods(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      paymentServie.getAllPaymentMethods,
      action?.payload
    );
    console.log("get cards----",data,originalError)
    if (ok) {
      const { paymentMethods: cards } = data || {};
      yield put(
        updateAuth({
          cards,
        })
      );
    } else {
        yield put(
          updateAuth({
            cards: [],
          })
        );
      onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* getMySubscriptonSaga(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      authServie.getMySubscription,
      action?.payload
    );
    console.log("mySubscriptions----",data,originalError)
    if (ok) {
      const { subscriptions: mySubscriptions } = data || {};
      yield put(
        updateAuth({
          mySubscriptions,
        })
      );
    } else {
        yield put(
          updateAuth({
            mySubscriptions: [],
          })
        );
      onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* cancelSubscriptionSaga(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      paymentServie.cancelSubscription,
      action?.payload
    );
    console.log("cancel subscription----",data,originalError)
    if (ok) {
      yield put(
        updateAuth({
          cancelSubscription:true,
        })
      );
      yield delay(500)
      yield put(
        updateAuth({
          cancelSubscription:false,
        })
      );
      toast.success("Your subscription has been cancelled successfully",toastConfiguration)
    } else {
        
      onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* renewSubscriptionSaga(action) {
  try {
    const { ok, data, originalError, status } = yield call(
      paymentServie.renewSubscription,
      action?.payload
    );
    console.log("renew subscription----",data,originalError)
    if (ok) {
      yield put(
        updateAuth({
          cancelSubscription:true,
        })
      );
      yield delay(500)
      yield put(
        updateAuth({
          cancelSubscription:false,
        })
      );
      toast.success("Your subscription has been renewed successfully",toastConfiguration)
    } else {
        
      onError(data, originalError);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);
    // console.log("error-----------", error);
  } finally {
  }
}
function* toggleWishlistItemSaga(action) {
  const { id, itemDetail } = action?.payload || {};
  try {
    const { ok, data, originalError } = yield call(
      authServie.toggleWisthListItem,
      { id }
    );
    // console.log("toggleWishlistItemSaga------", data);
    if (ok) {
      let { message } = data || {};
      toast(message, toastConfiguration);
      yield put(
        updateItem({
          itemDetail,
        })
      );
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    // console.log("error-----------", error);
  } finally {
  }
}
function* authSaga() {
  yield takeLatest(RegisterAction, registerSaga);
  yield takeLatest(VerifyOtpAction, verifyUserSaga);
  yield takeLatest(SendOtpAction, sendOtpSaga);
  yield takeLatest(EditBasicInfoAction, editBasicInfoSaga);
  yield takeLatest(ChangePasswordAction, changePasswordSaga);
  yield takeLatest(LoginAction, loginSaga);
  yield takeLatest(LogoutAction, logoutSaga);
  yield takeLatest(resetPasswordAction, resetPasswordSaga);
  yield takeLatest(resetPasswordRequestAction, resetPasswordRequestSaga);
  yield takeLatest(GetUserDetail, getUserDetailSaga);
  yield takeLatest(GetWishlistItemsAction, getWishlistItemsSaga);
  yield takeLatest(ToggleWishlistItemAction, toggleWishlistItemSaga);
  yield takeLatest(GetAllPaymentMethods, getAllPaymentMethods);
  yield takeLatest(CancelSubscription, cancelSubscriptionSaga);
  yield takeLatest(RenewSubscription, renewSubscriptionSaga);
  yield takeLatest(GetMySubscription, getMySubscriptonSaga);
}

export default authSaga;
